<template>
<div class="quote-aside">	
	<!-- :class="{'quote-aside-fixed':isFixed && fixedAll && !isMinWidth}" -->
	<div ref="aside" class="quote-aside-pannel">
		<div class="quote-aside-loading" v-if="quoteLoading">
			<img :src="$imgList.loading_0" alt="">
		</div>
		<!-- :class="{'quote-aside-fixed':isFixed && !fixedAll && !isMinWidth}" -->
		<div class="quote-aside-title pd-l-bs fs-xl">			
			{{LANG.pricing_information}}
			<a @click="getcheckParams" style="text-decoration: underline;" class="uline fl-gt mg-r-bs fc-main fs-md cursor-pointer" v-if="valuation">{{LANG.quote_parameters}}</a>
		</div>		
		<div v-if="valuation" class="quote-aside-box pd-lg-bs">
			<!-- --------pcb類型 材質-------- -->
			<pcb-price @issales="getpcbSales" @checkpcbdeltime="getpcbdeltime"></pcb-price>
			<!-- --------pcb類型 材質 end-------- -->
			<!-- -------------smt start---------- -->
			<smt-price></smt-price>
			<!-- -------------smt end---------- -->
			<!-- -------------smd start---------- -->
			<smd-price></smd-price>
			<!-- -------------smd end---------- -->

			<!-- 阶梯价格 -->
			<ladder-price v-if="(relation === 'pcb' || stay === 'pcb')"></ladder-price>

			<div class="quote-aside_shipment pd-b-bs">
				<np-collapse :title="LANG.shipment">
					<src-select :srctype="2" @input="countryChange" @selected="countrySelected" class="mg-b-xs"  style="width: 100%; z-index: 19;" v-model="country" :items="countrys">					
						<template v-slot:valstart="item">
							<i v-if="item&&item.item[country]" class="iti-flag vlm mg-r-xs" :class="[item.item[country].region_code.toLowerCase()]"></i>
						</template>
						<template v-slot:default="items">
							<i v-if="items&&items.item&&items.item.value" class="iti-flag vlm" :class="[items.item.value.region_code.toLowerCase()]"></i>	
						</template>					
					</src-select>
					
					<!-- <src-select :srctype="0" @input="expressChange"   @selected="expressSelected" style="width: 100%;" v-model="express" :items="expressList">
						<i slot="valstart" style="font-size: 0;" class="mg-r-xs vlm">
							<img class="vlm" :src="getexpressCode(express)" height="16">
						</i>
					</src-select> -->
					<template v-for="(v,i) in expressList">
					<div class="pd-t-md pd-b-xs" :key="i" v-if="v.real !== 36">
						<p class="clearfix">
							<span class="fl-lt">
								<check-box @change="expressSelected" class="vlm mg-l-xs mg-r-sm"  v-model="express" :val="v.real"  :radio="true"  shape="cir"></check-box>
								<img class="vlm" :src="getexpressCode(v.real)"  width="34" height="21">	
								<i class="vlm mg-l-sm fs-fw">{{v.shipping_name}}</i>
							</span>
						</p>
						<p class="fs-sm pd-t-sm pd-l-bs">				
							<span class="fl-gt  fs-md">$ {{v.freight}}</span>		
							<img class="vlm mg-lg-sm" src="//static.nextpcb.com/images/quote/planIcon.png" >
							<i class="vlm fc-dis">{{v.shipping_time}},{{LANG.weight}}: {{valuation.weight}} kg</i>
						</p>
					</div>
					</template>
				</np-collapse>
			</div>		
			
			<div class="quote-aside_showprice pd-tb-sm">
				<!------------- PCB 相關 --------------- -->
				<div class="quote-aside_showprice-line pd-tb-xs" v-if="pcb">
					<span>{{LANG.pcb_price}}</span>
					<span class="fl-gt">${{(valuation.outbound == 1?"?":pcbdeltime.pcb_total_original||pcbdeltime.total) || 0}}</span>
				</div>
				<!-- pcb优惠 -->
				<div class="quote-aside_showprice-line pd-tb-xs" v-if="discount.pcb && discount.pcb.discount_amount && ispcbSale">
					<span class="fc-err fs-sm">{{discount.pcb.title}}</span>
					<span class="fl-gt fc-err"><em class="fs-sm">-</em> ${{$tools.keepDecimal(discount.pcb.discount_amount,2)}} </span>
				</div>
				<!------------- PCB 相關  end --------------- -->
				<!-- Assembly Service Cost -->
				<div class="quote-aside_showprice-line pd-tb-xs" v-if="assembly">
					<span>{{LANG.assembly_service_cost}}</span>
					<span class="fl-gt">${{assembly.total}}</span>
				</div>
				<!-- Assembly Service Cost end-------->
				<!-- Stencil Cost -->
				<div class="quote-aside_showprice-line pd-tb-xs" v-if="stencil">
					<span>{{LANG.stencil_cost}}</span>
					<span class="fl-gt">${{stencil.total}}</span>
				</div>
				<!-- Shipping Cost -->
				<div class="quote-aside_showprice-line pd-tb-xs">
					<span>{{LANG.shipping_cost}}</span>
					<span class="fl-gt">${{valuation.freight}}</span>
				</div>
				<!-- Shipping Cost优惠 -->
				<div class="quote-aside_showprice-line pd-tb-xs" v-if="discount.freight && discount.freight.amount">
					<span class="fc-err fs-sm">{{discount.freight.title}}</span>
					<span class="fl-gt fc-err"> <em class="fs-sm">-</em>${{$tools.keepDecimal(discount.freight.amount,2)}} </span>
				</div>
			</div>
			<!-- total -->
			<div class="quote-aside_total">
				<div class="quote-aside_total-line pd-tb-sm">
					<span class="f-bold">{{LANG.total}}</span>
					<span class="fl-gt f-bold fc-tips">${{valuation.outbound == 1?"?":total}}</span>
				</div>
				<div class="tr quote-aside_total-line pd-b-sm" v-if="!isLogin">
					<span class="td vlm" style="vertical-align: top;">
						<span class="t_text f-bold">
						{{LANG.email}}:
						</span>
					</span>
					<span class="td" style="width: 260px;">
						<np-input v-model.trim="email"  width="240px"></np-input>						
					</span>
				</div>
			</div>
			<!-- 提交 -->
			<button style="width: 100%;" @click="checkAddtoCart" class="np-btn mg-t-md np-btn-main np-btn-lg">
				<i class="icon">&#xe62a;</i>
				{{LANG.add_to_cart}}
			</button>
			<p class="fc-quotetips pd-tb-xs fs-sm" v-text="LANG.quote_result_tips1"></p>
			<!-- note -->
			<!-- <dl class="fc-dis fs-sm pd-tb-bs">
				<dt>{{LANG.note}}:</dt>
				<dd>{{LANG.note_1}}</dd>
				<dd>{{LANG.note_2}}</dd>
				<dd>{{LANG.note_3}}</dd>
				<dd>{{LANG.note_4}}</dd>
			</dl> -->
		</div>
		<div v-else class="fc-gnr pd-lg-bs pd-tb-md">
			{{LANG.calcualte_tips}}
			<a class="np-btn np-btn-box np-btn-main pd-tb-sm mg-t-bs rs-sm" @click="calculateClick">
				<i class="icoy icon-calc f-baselge  mr5 vlm"></i>
				<span class=" vlm">{{LANG.calculate}}</span>
			</a>
		</div>
		<!-- 下单须知 -->
		<p class="order-instruction">
			<a @click="clickOrderInstruction">{{ LANG.order_instructions }}</a>
		</p>
	</div>
	<!-- !valuation && ads.length -->
	<div class="quote-aside_ad mg-t-md">
		<!-- 廣告 -->
		<template v-for="(v,i) in ads">
		<a class="quote-aside_adimg mg-b-md" v-if="v.ad_fixed" :key = "i" 
			:target="v.ad_fixed.target"
			:href="v.ad_fixed.link !== ''?v.ad_fixed.link:false"
		>
			<img :width="v.ad_fixed.width" :height="v.ad_fixed.height" :src="v.ad_fixed.banner" :alt="v.ad_fixed.desc">
		</a>			
		</template>		
	</div>
	<!-- 登錄彈出窗 -->
	<login-win :dftemail="email" v-model="loginWinShow" @loginsuccess = "loginsuccess"></login-win>
	<!-- 下单须知弹窗 -->
	<confirm-modal :options="orderOptions" v-if="orderVisible" :show="orderVisible" @closeConfirm="orderVisible=false">
		<div slot="content" class="order-instruction-content">
			<p>{{ LANG.order_instructions_call }}：</p>
			<p>{{ LANG.order_instructions_tips }}</p>
			<h3>{{ LANG.order_instructions_tip1 }}</h3>
			<p>{{ LANG.order_instructions_tip1a }}</p>
			<p>{{ LANG.order_instructions_tip1b }}</p>
			<p>{{ LANG.order_instructions_tip1c }}</p>
			<p>{{ LANG.order_instructions_tip1d }}</p>
			<p>{{ LANG.order_instructions_tip1e }}</p>
			<p>{{ LANG.order_instructions_tip1f }}</p>
			<p>{{ LANG.order_instructions_tip1g }}</p>
			<p>{{ LANG.order_instructions_tip1h }}</p>
			<p>{{ LANG.order_instructions_tip1i }}</p>
			<p>{{ LANG.order_instructions_tip1j }}</p>
			<h3>{{ LANG.order_instructions_tip2 }}</h3>
			<p class="f-bold">{{ LANG.order_instructions_tip2_1 }}</p>
			<p>{{ LANG.order_instructions_tip2_1a }}</p>
			<p>{{ LANG.order_instructions_tip2_1b }}</p>
			<p>{{ LANG.order_instructions_tip2_1c }}</p>
			<p>{{ LANG.order_instructions_tip2_1d }}</p>
			<p class="f-bold">{{ LANG.order_instructions_tip2_2 }}</p>
			<p>{{ LANG.order_instructions_tip2_2a }}</p>
			<p>{{ LANG.order_instructions_tip2_2b }}</p>
			<p>{{ LANG.order_instructions_tip2_2c }}</p>
			<p>{{ LANG.order_instructions_tip2_2d }}</p>
			<p>{{ LANG.order_instructions_tip2_2e }}</p>
			<p>{{ LANG.order_instructions_tip2_2f }}</p>
			<p class="f-bold">{{ LANG.order_instructions_tip2_3 }}</p>
			<p>{{ LANG.order_instructions_tip2_3a }}</p>
			<p>{{ LANG.order_instructions_tip2_3b }}</p>
			<p>{{ LANG.order_instructions_tip2_3c }}</p>
			<p>{{ LANG.order_instructions_tip2_3d }}</p>
			<p>{{ LANG.order_instructions_tip2_3e }}</p>
			<p class="f-bold">{{ LANG.order_instructions_tip2_4 }}</p>
			<p>{{ LANG.order_instructions_tip2_4a }}</p>
			<p>{{ LANG.order_instructions_tip2_4b }}</p>
			<p class="f-bold">{{ LANG.order_instructions_tip2_5 }}</p>
			<p>{{ LANG.order_instructions_tip2_5a }}</p>
			<p>{{ LANG.order_instructions_tip2_5b }}</p>
			<p class="f-bold">{{ LANG.order_instructions_tip2_6 }}</p>
			<p>{{ LANG.order_instructions_tip2_6a }}</p>
			<p>{{ LANG.order_instructions_tip2_6b }}</p>
			<p>{{ LANG.order_instructions_tip2_6c }}</p>
			<p>{{ LANG.order_instructions_tip2_6d }}</p>
			<p>{{ LANG.order_instructions_tip2_6e }}</p>
			<p>{{ LANG.order_instructions_tip2_6f }}</p>
			<p class="f-bold">{{ LANG.order_instructions_tip2_7 }}</p>
			<p>{{ LANG.order_instructions_tip2_7a }}</p>
			<p>{{ LANG.order_instructions_tip2_7b }}</p>
			<h3>{{ LANG.order_instructions_tip3 }}</h3>
			<p>{{ LANG.order_instructions_tip3a }}</p>
			<p>{{ LANG.order_instructions_tip3b }}</p>
			<p>{{ LANG.order_instructions_tip3b1 }}</p>
			<p>{{ LANG.order_instructions_tip3b2 }}</p>
			<p>{{ LANG.order_instructions_tip3c }}</p>
			<p>{{ LANG.order_instructions_tip3d }}</p>
			<p>{{ LANG.order_instructions_tip3e }}</p>
			<p>{{ LANG.order_instructions_tip3f }}</p>
			<h3>{{ LANG.order_instructions_tip4 }}</h3>
			<p>{{ LANG.order_instructions_tip4a }}</p>
			<p>{{ LANG.order_instructions_tip4b }}</p>
			<p>{{ LANG.order_instructions_tip4c }}</p>
			<p>{{ LANG.order_instructions_tip4d }}</p>
			<p>{{ LANG.order_instructions_tip4e }}</p>
			<p>{{ LANG.order_instructions_tip_note }}</p>
		</div>
	</confirm-modal>

	<!-- 上传文件弹窗 -->
	<upload-file-modal v-if="uploadFileVisible" :visible="uploadFileVisible" :params="Object.assign(params, {page: 'quote'})" @handleUploadFileSubmit="handleUploadFileSubmit"/>

	
</div>
</template>
<script>
import checkbox from '@/_module/checkbox/index.vue'
import srcselect from '@/_module/srcselect/index.vue'
import input from '@/_module/input/index.vue'
import pcbPrice from '@/components/quote/quoteaside/pcb_price.vue'
import smtPrice from '@/components/quote/quoteaside/smt_price.vue'
import smdPrice from '@/components/quote/quoteaside/smd_price.vue'
import ladderPrice from '@/components/quote/quoteaside/ladder_price.vue'
import loginWin from '@/components/public/loginwin.vue'
import uploadFileModal from '@/components/public/uploadFileModal.vue'
import npCollapse from '@/_module/collapse/index.vue'
import { createQuoteParamsWin } from '@/mixins/quote/fr4NoParams.js'
export default {
	name: 'quote_aside',
	data(){
		return {
			ispcbSale: false, //pcb折扣是否是首单免费或者 特价
			express:"",
			country: "",
			email:"",
			loginWinShow:false,
			isRelation:true,
			pcbdeltime:{},
			countrys:[],
			calcArea: 0, //pcb计价页前端计算出来的面积
			orderOptions: {
        area:["817px", '650px'],
        skin:"quote-size-conver_alert",
        title: '下单须知', 
				btns: []
      },
			orderVisible: false,
			uploadFileVisible: false,
			gaCount:0, // 谷歌ga推送次数
			fixedAll: true
		} 
	},
	mounted(){		
		this.setDefaultData();
		this.getRegion(()=>{
			setTimeout(()=>{
				let top = this.$store.state.top;
				//根据语言code设置默认国家
				if(top.languageActive){
					if(top.languageActive.code == "ja-jp"){
						this.country = 102;
					}
				}	
			},1060)				
		});
		this.getAdinfo();
		this.$bus.$on('pcbCalcArea', (calcArea) => {
			console.log(182, calcArea)
			this.calcArea = calcArea
		})
	},
	computed:{
		total(){
			var total = this.valuation.total;	
			console.log(284, total, this.pcbdeltime, this.discount)
			if(this.pcbdeltime.sale && this.discount && this.discount.pcb && this.discount.pcb.key == "new_customer_first_free"){
				total = this.$tools.keepDecimal(Number(total) + Number(this.pcbdeltime.sale),2);
			}
			return total;
		},
		aside_param(){
			return this.$store.state.quote.aside_param
		},
		ads(){		
			let adsCode = this.getAdsCode(),ads = [];
			if(adsCode){
				if(adsCode[0]){
					let a1 = this.$store.getters.getAds(adsCode[0]);
					if(a1) ads.push(a1);					
				}
				
				if(adsCode[1]){
					let a2 = this.$store.getters.getAds(adsCode[1]);
					if(a2) ads.push(a2);
				}
			}
			return ads;
		},
		stay(){
			return this.$store.state.quote.stay;
		},
		relation(){
			return this.$store.state.quote.relation;
		},
		discount(){			
			return this.valuation.discount || {};
		},
		quoteLoading(){
			return this.$store.state.quote.quoteLoading;
		},
		isLogin(){
			return this.$store.getters.isLogin;
		},	
		valuation(){
			return this.$store.getters.getQuoteValuation;
		},
		pcb(){
			if(this.valuation && this.valuation.list && this.valuation.list.pcb)  return this.valuation.list.pcb;		
			return null;
		},
		assembly(){
			if(this.valuation && this.valuation.list && this.valuation.list.assembly) return this.valuation.list.assembly;			
			return null;
		},
		stencil(){
			if(this.valuation && this.valuation.list && this.valuation.list.stencil) return this.valuation.list.stencil;			
			return null;
		},
		expressList(){
			let expressList = this.$store.getters.getQuoteExpressList;
			try{
				expressList.forEach((v)=>{
					v.real = v.shipping_id;
					v.word = v.shipping_name;
				})	
			}catch(e){
				//TODO handle the exception
				expressList = null;
			}			
			return expressList;
		},
		params(){
			return this.$store.getters.getQuoteParams;
		},
		isFixed(){
			return this.$store.state.isFixed
		},
		isMinWidth(){
			return this.$store.state.isMinWidth
		}
	},
	methods:{
		handleUploadFileSubmit(type, fileData) {
			this.uploadFileVisible = false;			
			if(type === 'submit') {
				if(fileData.pcbFile.fid) {
					this.$store.commit("setQuoteParams",{value:fileData.pcbFile.fid,key:"aside_param.gerber_file_id"});
					this.$store.commit("setQuoteParams",{value:fileData.pcbFile.url,key:"aside_param.gerber_file"});
				}
				if(fileData.bomFile.fid) {
					this.$store.commit("setQuoteParams",{value:fileData.bomFile.fid,key:"aside_param.bom_file_id"});
					this.$store.commit("setQuoteParams",{value:fileData.bomFile.url,key:"aside_param.bom_file"});
				}
				if(fileData.centroidFile.fid) {
					this.$store.commit("setQuoteParams",{value:fileData.centroidFile.fid,key:"aside_param.other_file_id"});
					this.$store.commit("setQuoteParams",{value:fileData.centroidFile.url,key:"aside_param.other_file"});
				}
				this.dispachTocart()
			}
		},
		getcheckParams(){
			this.$alert.confirm({
				title:"Quote Parameters",
				skin:"quote-size-conver_alert quote-params-check-table",
				shadeClose: true,
				area:["780px","620px"],					
				content: createQuoteParamsWin(this.params,this.LANG),
				btns: []
			})
		},
		clickOrderInstruction() {
			this.orderOptions.title = this.LANG.order_instructions
			this.orderVisible = true
		},
		calculateClick(e){		
			this.countCalc(e);
		},
		getpcbdeltime(item){
			this.pcbdeltime = item;
		},
		getexpressCode(express){
			let expressList = this.expressList;
			if(expressList && expressList.length){
				let rst,ov;
				expressList.forEach((v)=>{
					if(express == v.real){
						ov = v;
						return rst = v.shipping_logo;
					}
				})
				if(rst) return rst;
				if(ov) {
					try{
						return '//static.nextpcb.com/images/delivery/' + ov.shipping_code.replace(/\s/,"") + '.png';
					}catch(e){
						console.log(e.message)
					}	
				}
			}
			return '//static.nextpcb.com/images/delivery/' + express + '.png';
		},
		getpcbSales(e){			
			this.ispcbSale = e;
			console.log(422, this.ispcbSale)
		},
		loginsuccess(){
			//登錄成功 重新計價
			this.countCalc();
			this.$store.dispatch("getCommonData");
		},
		getAdsCode(){
			let ads = [],A1,A2;
			if(this.stay == 'pcb'){
				A1 = "A05";
				A2 = "A06";
			}else if(this.stay == 'smt'){
				A1 = "A07";
				A2 = "A08";
			}else if(this.stay == 'fpc' || this.stay == 'rfpc'){
				A1 = "A09";
				A2 = "A10";
			}
			if(A1){
				ads.push(A1)
			}
			if(A2){
				ads.push(A2)
			}
			return ads;
		},
		getAdinfo(){
			let ads = this.getAdsCode();
				if(ads.length){
					this.$store.dispatch("getAdinfo",{banner_code:ads.join(",")});
				}			
		},
		checkAddtoCart(){
			let _this = this;
			let reg = this.$tools.regs.email;
			let stayOk = this.$store.getters.isQuoteParamsOk(this.stay);
			let relationOk = this.relation?this.$store.getters.isQuoteParamsOk(this.relation):true;
			if(!stayOk ||  !relationOk) return this.$alert.msg(this.LANG.params_is_not_complete);
			if(!this.isLogin){
				//未登錄 彈出登錄彈窗					
				if(reg.test(this.email)){
					//判斷郵件是否填寫
					this.loginWinShow = true;
					return this.$store.dispatch("quoteRecodeNonMember",this.email);
				}
				return this.$alert.msg(this.LANG.qmsginfo_enterarealemail);									
			}
			
			if(this.params.blayer > 3 && this.params.blayer <= 20 && this.params.pbnum > 4){
				this.$alert.msg(this.LANG.pbnum_limit_tip)
				return false
			}

			if(this.stay === 'pcb' || this.relation === 'pcb'){
				console.log(344, this.params)
				if(!this.params.period_format){
					//ul mark 提示
					return this.$alert.confirm({
						area:["350px"],
						title: this.LANG.tips,
						content:this.LANG.ul_mark_tips,
						btns:[{
								text: this.LANG.ok,
								callBack(e){
									//跳转到选取区域，不加入购物车\
									let ulmarkOffset = _this.$store.getters.getElementOffset("quote_ulmark");
									window.scrollTo(0,ulmarkOffset.top || 0);
									e.close();
								}
							},
							{
								text:this.LANG["don't need"],
								callBack(e){									
									_this.addtoCart();
									e.close();
								}
						}]
					})
				}
			}
			return	_this.addtoCart();			
		},
		addtoCart(){
			console.log(523, this.params)
			// 现在只有pcb和钢网得订单会走这里
			if(this.params.gerber_file_id) {
				this.dispachTocart()
			} else {
				this.$alert.msg(this.LANG.please_upload_file)
			}
			//判断是否需要添加关联订单
			// let vm = this;
			// if(this.stay === 'pcb'){
			// 	if(this.isRelation){
			// 		this.$alert.confirm({
			// 			area:["350px"],
			// 			title: this.LANG.tips,
			// 			closeBtn:false,
			// 			content: this.LANG.qmsginfo_proceedyourpcborder,
			// 			btns:[
			// 				{
			// 					text:this.LANG.yes,
			// 					callBack(e){
			// 						//自动关联
			// 						vm.$store.commit("setQuoteRelation","smt");
			// 						vm.isRelation =  true;
			// 						let smtOffset = vm.$store.getters.getElementOffset("smt_height");
			// 						try{
			// 							window.scrollTo(0,smtOffset.top || 0);
			// 						}catch(e){
			// 							//TODO handle the exception
			// 						}									
			// 						e.close();
			// 					}
			// 				},
			// 				{
			// 					text:this.LANG.no,
			// 					callBack(e){
			// 						vm.isRelation =  false;
			// 						vm.judgeShowUploadFile()
			// 						// vm.dispachTocart();
			// 						e.close();
			// 					}
			// 				}
			// 			]
			// 		})
			// 	}else{
			// 		vm.judgeShowUploadFile()
			// 		// vm.dispachTocart()
			// 	}
			// }else{
			// 	vm.judgeShowUploadFile()
			// 	// vm.dispachTocart()
			// }			
		},
		dispachTocart(){			
			this.$store.dispatch("addtoCart").then((res)=>{				
				if(res && res.code !== 200){
					this.$alert.msg(res.msg);
					this.isRelation =  false;
				}else{
					this.isRelation =  true;
				}
			});		
		},
		setDefaultData(){
			//獲取物流和參數信息			
			let params = this.$store.getters.getQuoteAsideParams;				
			for(let k in params){
				this[k] = params[k];
			}	
		},
		async getRegion(bc){
			// 获取用户访问IP所属国家
			const visitRegionRes = await this.$http.get(this.$api.getRegionByIp)
			const visitRegionId = visitRegionRes.data.region_id || 211
			this.country = visitRegionId
			//國家數據
			let ajaxregion =  this.$tools.getSlocal("ajaxregion");
			if(ajaxregion){
				this.countrys =  ajaxregion
				if(typeof bc === "function") bc(ajaxregion);
				return ;
			}
			return this.$http.get(this.$api.ajaxregion).then((res)=>{
				if(res.code == 200){
					res.data.forEach((v)=>{
						v.word = v.region_name;
						v.real = v.region_id;
					})	
					this.countrys =  res.data;
					this.$tools.setSlocal("ajaxregion",res.data);
					if(typeof bc === "function") bc(res.data);
				}
				return res;
			})
		},
		countrySelected(){
			this.express = ''
			setTimeout(()=>{
				this.countCalc();
			})			
		},
		expressSelected(){
			setTimeout(()=>{
				this.countCalc();
			})	
		},
		countryChange(val){
			this.country = val;
		},
		// expressChange(val){			
		// 	this.express = val;
		// },
		countCalc(isbtn){
			//計價方法
			/*
			1,面積大於0 説明 必填參數已齊全，可以傳遞參數
			*/		
			let stayOk = this.$store.getters.isQuoteParamsOk(this.stay);
			let relationOk = this.relation?this.$store.getters.isQuoteParamsOk(this.relation):true;
			let calculate_params = this.$store.getters.getQuoteParams;
			if(stayOk &&  relationOk){
				return	this.$store.dispatch("calcQuoteValuation");
			}
			if(isbtn){
				this.$store.commit("setQuoteBtnclick",true);
				if(this.stay !== 'smt'){
					if((!calculate_params.blength || !calculate_params.bwidth) && !calculate_params.bcount){
						return this.$alert.msg(this.LANG.pcbparams_is_not_complete_new);
					}
					if((!calculate_params.blength || !calculate_params.bwidth) && calculate_params.bcount){
						return this.$alert.msg(this.LANG.pcb_size_is_not_complete);
					}
					if((calculate_params.blength && calculate_params.bwidth) && !calculate_params.bcount){
						return this.$alert.msg(this.LANG.pcb_number_is_not_complete);
					}
				}else{
					if((!calculate_params.pcb_height || !calculate_params.pcb_width) && !calculate_params.number){
						return this.$alert.msg(this.LANG.params_is_not_complete_new);
					}
					if((!calculate_params.pcb_height || !calculate_params.pcb_width) && calculate_params.number){
						return this.$alert.msg(this.LANG.pcb_size_is_not_complete);
					}
					if((calculate_params.pcb_height && calculate_params.pcb_width) && !calculate_params.number){
						return this.$alert.msg(this.LANG.pcba_number_is_not_complete);
					}
				}
			}
			return this.$alert.msg(this.LANG.params_is_not_complete);
		}
	},
	watch:{
		relation(v){			
			if(v){
				this.isRelation = false;
			}else{
				this.isRelation = true;
			}			
		},
		country(v){
			this.$store.commit("setQuoteParams",{value:v,key:"aside_param.country"});
			this.$store.commit("setQuoteParams",{value:v,key:"aside_param.region_id"});			
		},
		express(v){
			this.$store.commit("setQuoteParams",{value:v,key:"aside_param.express"});
			//執行計價方法
			//this.countCalc();
		},
		expressList(v){
			let hasExpress;
			if(!v) return;
			if(!v.length) return;
			v.forEach((item)=>{
				if(item.real == this.express){
					hasExpress = item.real;
				}
			});
			if(!hasExpress){
				this.express = v[0].real;
			}
		},
		valuation(o){
			//设置deltime
			if(!o) return;
			if(this.stay === "pcb" || this.stay === "fpc" || this.stay === "rfpc" || this.relation === "pcb" || this.relation === "fpc" || this.relation === "rfpc"){
				if(o.list && o.list.pcb) {
					this.$store.commit("setQuoteParams",{value:o.list.pcb.deltime,key:"aside_param.deltime"});					
				}
			} else if(this.stay === "smt"){
				if(!this.relation){
					if(o.list && o.list.assembly) {
						this.$store.commit("setQuoteParams",{value:o.list.assembly.deltime,key:"aside_param.deltime"});					
					}
				}
			} else if(this.stay === "smd"){
				if(o.list && o.list.stencil) {
					this.$store.commit("setQuoteParams",{value:o.list.stencil.deltime,key:"aside_param.deltime"});					
				}
			}
			
			this.$nextTick(()=>{
				const winHeight = window.innerHeight || 0
				const asideDOM = this.$refs.aside || {}
				console.log(this.$refs,asideDOM,asideDOM.clientHeight)
				const divHeight = asideDOM.clientHeight ||0
				const canUseH = winHeight - 48 - 60
				console.log(winHeight,divHeight,canUseH)
				if(divHeight > canUseH){
					this.fixedAll = false
				}
				else{
					this.fixedAll = true
				}
			})
			// 谷歌ga4事件跟踪
			try {
				if(!window){
					return false
				}
				if(this.gaCount===0){
					this.gaCount++
					window.dataLayer.push({event:'pcbcostdisplayed'})
				}
			} catch (error) {
				console.error(error)
			}
		}
	},
	components: {
		'check-box':checkbox,
		'pcb-price':pcbPrice,
		'smt-price': smtPrice,
		'smd-price': smdPrice,
		'ladder-price': ladderPrice,
		'src-select':srcselect,		
		'np-input':input,
		'login-win':loginWin,
		'np-collapse':npCollapse,
		'upload-file-modal':uploadFileModal
	}
}
</script>

<style lang="scss">
.quote-aside {
	float: right;
	width: 30%;
	box-sizing: border-box;
	.quote-aside-pannel {
		position: relative;
		background-color: #fff;
	}
	.quote-aside-loading {
		position: absolute;
		z-index: 90;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0,0,0,0.4);
		img {
			position: absolute;
			left: 50%;
			top: 50%;
			z-index: 99;
			@include  transform(translate(-50%,-50%));
		}
	}
	.quote-aside_total-line {
		.td {
			line-height: 32px;
		}
		.t_text {
			display: inline-block;
		}
	}
	.coupon-tip {
		color: #FC6121;
	}
	.order-instruction {
		text-align: right;
		padding-right: 20px;
		padding-bottom: 10px;
		a {
			cursor: pointer;
			color: $color-purple;
			text-decoration: underline;
		}
	}
	.order-instruction-content {
		h3 {
			font-weight: 700;
			padding: 10px 0;
			font-size: 16px;
		}
		p {
			line-height: 1.8;
		}
	}
	.collapse-wrap {
		.title {
			padding: 20px 0 10px 0;
			&-name {
				font-size: 14px;
			}
		}
	}
}

.quote-aside-fixed{
	width: 360px;
	background: #fff;
	position: fixed !important;
	left: 50%;
	top: calc(48px + 60px);
	transform: translateX(-50%);
	margin-left: 420px;
	z-index: 100;
	box-sizing: border-box;
}
</style>
